module.exports = __webpack_public_path__ + "static/media/toshiba-schedule_nexus.4d340fd0.jpg";